<template>
  <div class="kanban-cards" style="position: relative; height: 100%; width: 100%; overflow: auto">
    <portal to="v-task-group">
      <div class="d-flex no-wrap mt-2 mt-md-0">
        <div v-if="userList.length > 1" style="max-width: 200px">
          <v-autocomplete
            class="ml-2"
            outlined
            :items="userList"
            menu-props="offset-y, auto, overflowY"
            :value="user_id"
            @input="
              //   user_id = department_id || $event ? $event : $root.profile.id;
              user_id = $event;
              fillColumns(data);
            "
            :label="$t('Пользователь')"
            :clearable="!!department_id || true"
            hide-details
            dense
          />
        </div>
        <div v-if="depList.length" style="max-width: 280px">
          <a-input-select
            class="ml-2"
            :value="department_id"
            @input="
              //if (!user_id && !$event) user_id = $root.profile.id;
              department_id = $event;
              fillColumns(data);
            "
            :config="{ dense: true, hideDetails: true }"
            :model="{
              name: 'department_id',
              title: 'Отдел',
              options: depList,
              autocomplete: true,
            }"
          />
        </div>
      </div>
    </portal>
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
    <Kanban
      :columns.sync="columns"
      col-min-width="350"
      col-max-width="400"
      count-text="элементов"
      drop-text="Переместите сюда"
      @status-change="columnChange"
      @sort="columnSort($event)"
      :readonly="!getAccess('task.status')"
      :height="height"
    >
      <template v-slot:card="{ item }">
        <div class="item" :style="{ 'border-left-color': itemStatus(item.status).color }">
          <div class="kanban-card">
            <Card
              :d_start="d_start"
              :item="item"
              @show-card="$emit('show-card', $event)"
              :key="item.id"
              @click-task1="$emit('click-task', $event)"
              @click-action1="$emit('click-action', $event)"
            />
          </div>
        </div>
      </template>
    </Kanban>
  </div>
</template>

<script>
import { getAccess, autoHeightBlock, genModel, statusDoc } from "@/components/mixings";
import Kanban from "./kanban.vue";
import { defaults } from "lodash";
import { nextTick } from "vue";

export default {
  mixins: [getAccess, autoHeightBlock, genModel, statusDoc],
  props: {
    api: String,
    height: { type: Number, default: 400 },
    defaults: { type: Object, default: () => {} },
    config: { type: Object, default: () => {} },
    statusList: Array,
  },
  components: { Kanban, Card: () => import("./tasksCanbanCard") },
  computed: {
    notMobile() {
      return window.innerWidth >= 1025;
    },
  },
  data() {
    return {
      item: {},
      columns: [],
      typeGroup: -1,
      showDropdown: {},
      user_id: this.$root.profile.id,
      department_id: null,
      m: this.$store.getters["config/get"].models.tasks,
      opcoesDropdownMenu: [{ type: "customAction" }, { type: "separator", color: "yellow" }, { type: "customAction" }],
      upperDropPlaceholderOptions: {
        className: "cards-drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
      data: null,
      users: [],
      sources: [],
      source: null,
    };
  },
  computed: {
    userList() {
      let res = this.users.map((u) => {
        return { value: u.user_id, text: u.user_name };
      });
      return res;
    },
    depList() {
      let res = this.users
        .filter((u) => !!u.department_id)
        .map((u) => {
          return { value: u.department_id, text: u.department_name };
        });
      //console.log("dep list", res);
      return res;
    },
    d_start() {
      const selected = new Date();

      // Понедельник (1) как начало недели
      const start = new Date();
      const day = start.getDay(); // 0 (вс) — 6 (сб)
      start.setDate(selected.getDate() - ((day + 6) % 7));
      return new Date(start).date;
    },
    d_end() {
      const end = new Date(this.d_start);
      end.setDate(end.getDate() + 6);
      return new Date(end).date;
    },
    statuses() {
      return (this.statusList || []).filter((s) => s.type === "task");
      return (this.statusList || []).filter((s) => [0, 1, 3, -2].includes(s.value));
    },
    overseer() {
      return this.getAccess("task.viewOverseer");
    },
  },
  watch: {},
  mounted() {
    this.initData();
  },
  methods: {
    async onChangeGroup() {
      await this.fitchData();
      this.makeUsers(this.data);
    },
    refresh() {
      this.fitchData();
    },

    itemStatus(value) {
      //let statuses = this.$store.getters["config/get"].models?.tasks?.statuses;
      let statuses = this.statuses;
      return statuses.find((x) => x.value == value) ? statuses.find((x) => x.value == value) : {};
    },
    async initData() {
      //let d = await this.$axios.get("accounting/dir/department/tags/department_director_employer_id");

      this.columns = [];
      this.groups = [];
      const statuses = this.statuses;
      const groups = [];
      for (const el of statuses) {
        this.columns.push({
          id: el.value,
          name: el.text || el,
          status: el.value,
          color: el.color,
          columnItems: [],
          type: el.type,
          next: el?.next || [],
        });
      }
      console.log("cccc", this.columns);
      await this.fitchData();
    },
    fillColumns(data, type = "clear") {
      if (!this.user_id && !this.department_id) {
        // this.user_id = this.$root.profile.id;
      }
      const canStatus = (d, s) => {
        if (d?.type == "auto") return false;
        let users = [];
        (s?.users || "user_id,createdby_id").split(",").forEach((u) => users.push(d[u]));
        //   console.log("can status", { d, s, users }, this.getAccess("task.status", { users }));
        return this.getAccess("task.status", { users });
      };
      let iShow = 0;
      const maxShow = 10;
      //      (this.statusCurrent?.users || "user_id,createdby_id").split(",").forEach(u => res.push(this.data?.[u]));

      if (type == "clear")
        this.columns.forEach((c) => {
          c.columnItems = [];
          c.items_ = [];
        });
      for (const el of data.filter((d) => {
        return (d.user_id == this.user_id || !this.user_id) && (d.department_id == this.department_id || !this.department_id) && (this.department_id || this.user_id);
      })) {
        if (el.status === null) el.status = 0;
        if (el.status || el.status === 0) {
          const idx = this.columns.findIndex((c) => c.status === el.status);
          if (idx >= 0) {
            let status = this.statuses.find((s) => s.value == el.status) || {};
            if (canStatus(el, status)) el.next = (this.statuses.find((s) => s.value == el.status) || {})?.next || [];
            if (el.status == 4 && false) {
              iShow++;
              if (iShow < maxShow) {
                this.columns[idx].columnItems.push(el);
                this.columns[idx].items_.push(el);
              }
            } else {
              this.columns[idx].columnItems.push(el);
              this.columns[idx].items_.push(el);
            }
          }
        }
      }
    },
    makeUsers(data) {
      this.users = [];
      if (!data) return;
      let u = [];
      let user = [{ user_id: this.$root.profile.id, user_name: this.$root.profile.name }];
      data.forEach((d) => {
        if (!u.includes(d.user_id)) {
          u.push(d.user_id);
          const { user_id, user_name, department_id, department_name } = d;
          user.push({ user_id, user_name, department_id, department_name });
        }
      });
      this.users = [...user];
    },
    async fitchData() {
      try {
        let where = {};
        let url;
        if (this.config.taskFilterMode.includes(2)) {
          url = "/mechti/tasks-admin";
        } else if (this.config.taskFilterMode.includes(4)) {
          url = "/mechti/tasks-department-director";
        } else if (this.config.taskFilterMode.includes(5)) {
          url = "/mechti/tasks-department-director-overseer";
        } else {
          url = "/mechti/tasks";
          if (this.config.taskFilterMode.includes(0) && this.config.taskFilterMode.includes(1)) {
          } else if (this.config.taskFilterMode.includes(0)) {
            //мои
            where = { user_id: this.$root.profile.id };
            //where.OR[({ user_id: this.$root.profile.id }, { createdby_id: this.$root.profile.id })];
          } else if (this.config.taskFilterMode.includes(1)) {
            //наблюдатель
          }

          //   where["AND"] = [...(where?.["AND"] || []), { type: { condition: "<>", value: "auto" } }];
        }
        if (this.m.hideCanbanAutoTask) where["AND"] = [...(where?.["AND"] || []), { type: { condition: "<>", value: "auto" } }];
        where["OR"] = [
          //{ AND: [{ date_start: { condition: ">=", value: this.d_start } }, { date_end: { condition: "<", value: new Date(this.d_start).addDays(27).date } }],          },
          {
            and: [
              { field: "date_start", condition: "<", value: new Date(this.d_start).addDays(7).date },
              { field: "status", condition: "not in", value: [-2, 3] },
            ],
          },
          {
            and: [
              { field: "date_start", condition: "<", value: new Date(this.d_start).addDays(7).date },
              { field: "updatedon", condition: ">", value: this.d_start },
            ],
          },
        ];
        //console.log("where", JSON.parse(JSON.stringify(where)));
        let params = this.config?.params
          ? this.config.params
          : {
              filters: where,
            };
        let d = await this.$axios.get(url, { params });
        let data = [...d.data.data];
        // this.user_id = this.$root.profile.id;
        //this.department_id = null;
        this.makeUsers(data);
        this.fillColumns(data);

        this.data = [...data];
      } catch (error) {
        console.error(error);
        this.$root.$emit("show-info", { text: "Ошибка загрузки данных" });
      }
    },

    selectStatus(item) {
      this.showDropdown = {
        id: item.id,
      };
    },
    async getTask(id) {
      let res = await this.$axios.get(this.api + "/" + id);
      return res.data.data;
    },
    async confirmStatus(item, s) {
      let ok = false;
      const status = this.statuses.find((f) => f.value === s) || {};
      if (status?.rules?.formula) {
        let rule = eval(status.rules.formula);
        const task = await this.getTask(item.id);
        if (task.id !== item.id) {
          this.refresh();
          return;
        }
        if (rule && !rule(task)) {
          this.$root.$emit("show-info", {
            text: status?.rules?.text || "Нет прав для переключения в этот статус",
            type: "error",
          });
          this.refresh();
          return;
        }
      }
      if (!ok) {
        ok = await this.$refs.confirmDialog.show({
          title: "Изменение статуса",
          message: [`Вы действительно хотите поменять `, ` статус на [${status?.text}]?`],
          okButton: "Да",
          cancelButton: "Нет",
        });
      }
      if (ok) {
        setTimeout(async () => {
          item.status = s;
          const data = {
            id: item.id,
            status: s,
          };
          if (status.type !== undefined) {
            data["type"] = status.type;
          }
          try {
            await this.$axios.post(this.api, data);
            this.$root.$emit("show-info", { text: "Статус обновлен" });
          } catch (error) {
            this.$root.$emit("show-info", { text: "Ошибка загрузки данных" });
          }
        });
      } else {
        this.refresh();
      }
    },

    columnChange({ item, status }) {
      this.confirmStatus(item, status);
    },
    columnSort(e) {},
  },
};
</script>

<style scoped>
.kanban {
  display: flex;
  justify-content: stretch;
  width: 100%;
  height: 100%;
  user-select: none;
}
.kanban__move-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  font-size: 0.9rem;
  color: #b0b0b0;
  user-select: none;
}
.kanban__move-icon span {
  margin-left: 10px;
}
.kanban__move-icon svg {
  width: 20px;
  height: 20px;
}
.kanban__drop-preview {
  position: relative;
  margin: 10px;
  background-color: #edf1f3;
  border: 2px dashed rgba(0, 0, 0, 0.059);
  border-radius: 4px;
}
.kanban__drop-preview::before {
  position: absolute;
  top: 50%;
  left: 50%;
  color: #b0b0b0;
  transform: translate(-50%, -50%);
}
.kanban__drop-preview::after {
  position: absolute;
  top: 50%;
  left: 27%;
  width: 20px;
  height: 20px;
  content: "";
  transform: translate(-50%, -50%);
}
.kanban__description {
  display: flex;
  align-items: center;
}
.kanban__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #edf5f7;
  padding: 0.5rem;
  border-radius: 8px;
}
.kanban__title {
  margin: 0 0 0 5px;
  font-size: 1rem;
  font-weight: bold;
  color: #555;
}
.kanban__quantity {
  margin-top: 0;
  font-size: small;
  color: #b0b0b0;
  text-align: right;
}
.kanban__quantity--inner-count {
  margin: 1rem 1rem 0 1rem;
  padding-top: 0.5rem;
}
.kanban__column {
  flex: 1;
  height: fit-content;
  padding: 10px;
  border-radius: 6px;
  transition: height 0.5s ease;
  border: 1px solid #e0e0e0;
}
.kanban__column:not(:first-of-type) {
  margin-left: 15px;
}
.kanban__column--no-border {
  border: none;
}
.kanban__header {
  margin-bottom: 15px;
  background-color: #fff;
}
.kanban__content {
  position: relative;
}
.kanban__skeleton {
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: 15px;
  padding-right: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
  overflow: auto;
}
.kanban__skeleton-container {
  width: 100%;
}
.kanban__skeleton-column {
  flex: 1;
  height: calc(100% - 30px);
  padding: 10px;
  margin-left: 15px;
  background-color: #e9e9e9;
  border-radius: 6px;
}
.kanban__skeleton-card {
  position: relative;
  height: 100px;
  padding: 15px;
  margin-top: 16px;
  background-color: #f5f5f5;
  border-radius: 6px;
}
.kanban__skeleton-card--one {
  position: absolute;
  top: 8px;
}
.kanban__skeleton-card--two {
  position: absolute;
  top: 8px;
  right: 10px;
}
.kanban__skeleton-card--three {
  position: absolute;
  top: 30px;
}
.kanban__skeleton-card--four {
  position: absolute;
  bottom: 2rem;
}
.kanban__skeleton-card--five {
  position: absolute;
  left: 1rem;
  bottom: 0.5rem;
}

.item,
.draggable-item,
.draggable-item-horizontal {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 8px;
  cursor: pointer;
  user-select: none;
  background-color: white;
  border: 1px solid transparent;
  border-left: 5px solid #e0e0e0;
  border-radius: 4px;
  transition: border-color 0.2s linear;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.1);
}
.item .card {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.item .card small {
  color: #838383;
}
.item.open {
  border-left: 5px solid #f3c1c1;
}
.item.executing {
  border-left: 5px solid #c4ebaf;
}
.item.finished {
  border-left: 5px solid #b3d5e9;
}
.item.paralised {
  border-left: 5px solid #dc3545;
}
.item.review {
  border-left: 5px solid #e0e0e0;
}
.badge {
  margin: 1rem 0;
  cursor: pointer;
}
.label {
  color: #838383;
  margin-bottom: 5px;
}
.kanban-action {
  display: flex;
  justify-content: space-between;
}

.kanban-button {
  max-width: 130px;
  pointer-events: none;
  border: none;
  color: #f7f7f7;
  padding: 1px 20px;
  text-align: center;
  text-decoration: none;
  border-radius: 100px;
}

.kanban-button.open {
  background-color: #f3c1c1;
}
.kanban-button.executing {
  background-color: #c4ebaf;
}
.kanban-button.finished {
  background-color: #b3d5e9;
}
.kanban-button.paralised {
  background-color: #dc3545;
}
.kanban-button.review {
  background-color: #e0e0e0;
}

.kanban-cards {
  display: flex;
  justify-content: center;
  margin: 5px 0;
}
</style>
